
class OmpBase
{
  constructor(opt = {})
  {
    this._viewer = opt.viewer || window.Viewer
  }

  /**
   * 屏幕坐标转换经纬度坐标
   */
  screenToLng(pos)
  {
    // 通过Viewer将屏幕坐标转换为世界坐标
    const worldPosition = this._viewer.camera.pickEllipsoid(pos)
    if (worldPosition)
    {
      // 使用椭球体参数获取经纬度坐标
      const ellipsoid = this._viewer.scene.globe.ellipsoid
      const cartographic = ellipsoid.cartesianToCartographic(worldPosition)
      const longitude = window.Cesium.Math.toDegrees(cartographic.longitude)
      const latitude = window.Cesium.Math.toDegrees(cartographic.latitude)
      return [longitude, latitude]
    }
    else
      return []
  }
}
export default OmpBase



// WEBPACK FOOTER //
// ./src/plugins/app/assembly/kyxxyzt/OmpBase.js